import { render, staticRenderFns } from "./BackToTopButton.vue?vue&type=template&id=0ab50146&scoped=true&lang=pug"
import script from "./BackToTopButton.vue?vue&type=script&lang=js"
export * from "./BackToTopButton.vue?vue&type=script&lang=js"
import style0 from "./BackToTopButton.vue?vue&type=style&index=0&id=0ab50146&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab50146",
  null
  
)

export default component.exports